module.exports = __webpack_public_path__ + "media/assets/img/flags/flag_black-04052b49a6762bd025c7a8de47ca5917.png";